import { Colors, Utils } from '@microfrontends/react-components'
import styled, { css } from 'styled-components'

export const CompanyImagePreview = styled.div<{ isEmpty?: boolean }>`
    padding: ${({ isEmpty }) => (isEmpty ? '0 50px 12px 50px' : '25px 25px 10px 25px')};
    background-color: ${({ isEmpty }) => (isEmpty ? '#F6F8FB' : '#f4f4f7')};
    border-radius: 6px 6px 0 0;
    ${({ isEmpty }) => {
        if (isEmpty) {
            return ''
        }
        return css`
            border: 1px solid ${Colors.cardShadow};
        `
    }}
    @media screen and (max-width: ${Utils.screens.mobile}px) {
        border: unset;
        ${({ isEmpty }) => {
            if (isEmpty) {
                return ''
            }
            return css`
                padding: 0;
                background-color: unset;
            `
        }}
    }
`

export const AboutUsDescription = styled.p<{ maxHeight: number }>`
    line-height: 22px;
    color: ${Colors.text};
    white-space: pre-line;
    overflow: hidden;
    transition: max-height 0.15s ease-in-out;
    margin-bottom: 16px;
    @media screen and (max-width: ${Utils.screens.mobile}px) {
        margin-bottom: 8px;
    }
    max-height: ${({ maxHeight }) => maxHeight}px;
`

export const ReadMoreButton = styled.span`
    line-height: 16px;
    color: ${Colors.primary};
    cursor: pointer;
    &:hover {
        color: ${Colors.button};
    }
`

export const AboutUsWrapper = styled.div`
    font-size: 14px;
    overflow: hidden;
`

export const ImageWrapper = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
`

export const InformationList = styled.ul`
    display: grid;
    row-gap: 10px;
    padding: 0;
    margin-bottom: 25px;
`

export const InformationItem = styled.li`
    display: grid;
    grid-template-columns: auto 1fr;
    @media screen and (max-width: ${Utils.screens.mobile}px) {
        grid-template-columns: 1fr;
        row-gap: 4px;
    }
    > .type {
        line-height: 22px;
        font-weight: 500;
        color: ${Colors.text};
        width: 100px;
        margin-bottom: 0;
    }
    > .text {
        margin-bottom: 0;
        color: ${Colors.text};
        line-height: 22px;
        > .dangerously-text {
            width: fit-content;
            display: inline-block;
        }
    }
`

export const AspectRatioContainer = styled.div<{ hasBorderRadius: boolean }>`
    position: relative;
    width: 100%;
    aspect-ratio: 3/2;
    overflow: hidden;
    ${({ hasBorderRadius }) => {
        if (!hasBorderRadius) {
            return ''
        }
        return css`
            border-radius: 12px;
        `
    }}
`

export const H2 = styled.h2`
    color: ${Colors.text};
    font-size: 22px;
    line-height: 28px;
    font-weight: 500;
    margin-bottom: 30px;
    @media screen and (max-width: ${Utils.screens.mobile}px) {
        font-size: 15px;
        margin: 0 0 10px 0;
    }
`
